module.exports = __webpack_public_path__ + "static/img/syabout.64f5dee.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/syabout.png
// module id = rS2K
// module chunks = 1